const Measure = Object.freeze({
  MENTIONS: 'Mentions',
  POSTS: 'Posts',
  FOLLOWERS: 'Followers',
  FOLLOWERS_NO_MEASURE: 'FollowersNoMeasure',
  FOLLOWERS_POSTS: 'FollowersPosts',
  ENGAGEMENTS: 'Engagements',
  ENGAGEMENTS_MENTIONS: 'EngagementsWithMentions'
})
export default Measure
export type MeasureStrings = typeof Measure[keyof typeof Measure]
// RESERVE BELOW
